
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community/subtypes/[slug]",
      function () {
        return require("private-next-pages/community/subtypes/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community/subtypes/[slug]"])
      });
    }
  